module.exports = __webpack_public_path__ + "img/jackpot.3895f82a.jpg";